module.exports = __webpack_public_path__ + "static/media/riri.3356ca77.png";